import Header from "../components/Common/Header/Header";
import Footer from "../components/Common/Footer/Footer";

export default function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}
